import { render, staticRenderFns } from "./ChessView.vue?vue&type=template&id=8e59b196&scoped=true&lang=pug"
import script from "./ChessView.vue?vue&type=script&lang=js"
export * from "./ChessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e59b196",
  null
  
)

export default component.exports